// extracted by mini-css-extract-plugin
export default {"backgroundImageWrapper":"CustomAppearance_backgroundImageWrapper__BzwmF","backgroundImage":"CustomAppearance_backgroundImage__VHBqy"};